import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GonvarriMiniCartComponent } from 'src/app/components/gonvarri-mini-cart/gonvarri-mini-cart.component';
import { I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { IconModule } from '@spartacus/storefront';

@NgModule({
  declarations: [
    GonvarriMiniCartComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    IconModule,
    I18nModule
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        MiniCartComponent: {
          component: GonvarriMiniCartComponent
        }
      }
    })
  ],
  exports: [
    GonvarriMiniCartComponent
  ]
})
export class GonvarriMiniCartModule { }
